export default{
    zqorder:{
        placeholderList:{
            placeholderinput:'商品名称/商品编号/订单编号',
            placeholderSelect:'请选择'
        },
        navList:{
            navitem1:'全部订单',
            navitem2:'待对账',
            navitem3:'待结算',
            navitem4:'已结算',
            navitem5:'已取消',
            navitem6:'逾期',
        },
        table:{
            step1:'对账期限',
            step2:'对账完成日期',
            step3:'最晚付款日',
            step4:'已逾期',
            step5:'滞纳金',
            step6:'结算单类型',
            step7:'结算状态',
            step8:'操作',
            step9:'结算单号',
            step10:'商家名称',
            step11:'结算单金额',
            step12:'对账日期',
            step13:'暂无数据',
            step14:'近三个月结算单',
            step15:'三个月以前的结算单'
        },
        msgState:{
            msg1:'距离逾期还有',
            msg2:'对账完成后',
            msg3:'个自然日',
            msg4:'系统生成',
            msg5:'提前结算',
            msg6:'天',
        },
        btnState:{
            btn1:'立即对账',
            btn2:'取消提前结算',
            btn3:'开发票',
            btn4:'验票',
            btn5:'立即支付',
            btn6:'账单详情',
        },
        confirmState:{
            confirm1:'提示',
            confirm2:'确定',
            confirm3:'取消',
            confirm4:'已取消',
            confirm5:'是否需要商家开发票?',
            confirm6:'要发票',
            confirm7:'不要发票',
        }
    }
}